import { isInExoSkeleton, navigate } from '@adsk/exo-skeleton-api';
export default (to => {
  if (isInExoSkeleton()) {
    navigate(to);
  } else if (window.exoNavigate) {
    window.exoNavigate(to);
  } else {
    window.location.assign(to);
  }
});
//# sourceMappingURL=navigate.js.map